var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useContext } from 'react';
import { AccordionGroupContext } from './AccordionGroupContext';
export const useAccordionGroup = () => {
    _react_refresh_temp_1();
    const [data, setData] = useContext(AccordionGroupContext);
    const setAccordionGroupExpandedId = useCallback((id) => {
        setData((prev) => {
            if (prev.allowCollapse) {
                return {
                    ...prev,
                    expandedId: id === prev.expandedId ? null : id,
                };
            }
            else {
                return prev.expandedId === id
                    ? prev
                    : {
                        ...prev,
                        expandedId: id,
                    };
            }
        });
    }, [setData]);
    return { accordionGroupData: data, setAccordionGroupExpandedId };
};
_react_refresh_temp_1(useAccordionGroup, "Y28rdGt7kJBguW7ZfEf6laxD/74=");
